import React, { useEffect, useState } from "react";
import '../../../cssfiles/homepage.css'
import { Card, Box, Typography, IconButton } from "@mui/material";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { useSelector, useDispatch } from 'react-redux';
import Widgetcreateupdate from "./Widgetcreateupdate";
import { Switch as AntdSwitch } from 'antd';
import {ConfigProvider} from 'antd';
import { updatetheme } from "../../../store/theme_data";
import Valuescard from "../../Widgets/Valuescard";
// import Leafletmapcard from "../../Widgets/Leafletmapcard";
import Linechartcard from "../../Widgets/Linechartcard";
import Barchartcard from "../../Widgets/Barchartcard";
import Areachartcard from "../../Widgets/Areachartcard";
import Piechartcard from "../../Widgets/Piechartcard";
import Googlemaps from "../../Widgets/Googlemaps";
import Azuremaps from "../../Widgets/Azuremaps";
import Circulargaugecard from "../../Widgets/Circulargaugecard";
import Semicirculargaugecard from "../../Widgets/Semicirculargaugecard";
import Speedgauge from "../../Widgets/Speedgauge";
import Lineargauge from "../../Widgets/Lineargauge";
import Temperaturegauge from "../../Widgets/Temperaturegauge";
import Timeseriestable from "../../Widgets/Timeseriestable";
import Statuscard from "../../Widgets/Statuscard";
import Setdatacard from "../../Widgets/Setdatacard";
import Switchcard from "../../Widgets/Switchcard";

import DropdownTable from "../../Dashboards/Graphs/Table/DropdownTable";
import DonutCategorywise from "../../Dashboards/Graphs/Donut/DonutCategorywise";
import MixedIndividual from "../../Dashboards/Graphs/Mixed/MixedIndividual";
import SwitchTable from "../../Dashboards/Graphs/Table/SwitchTable";
import Cardwidget from "../../Dashboards/Graphs/Card/Cardwidget"
import LinearProgressBar from "../../Dashboards/Graphs/LinearProgessBar/LinearProgessBar";
import SwitchGauge from "../../Dashboards/Graphs/Gauges/SwitchGauge";
import TextDonut from "../../Dashboards/Graphs/Donut/TextDonut";
import SwitchFunnel from "../../Dashboards/Graphs/Funnel/SwitchFunnel";
import LineChart from "../../Dashboards/Graphs/Line/LineChart";
import BarChart from "../../Dashboards/Graphs/Bar/BarChart";
import Treemap from "../../Dashboards/Graphs/Treemap/Treemap";
import Tablewidget from "../../Dashboards/Graphs/Table/Tablewidget";
import SankeyChart from "../../Dashboards/Graphs/Sankey/Sankey";
import Accordiontable from "../../Dashboards/Graphs/Table/AccordionTable";
//import Valuecard from "../../Dashboards/Graphs/ValueCard/Valuecard";
import { 
  setEditWidgetMode, 
  setEditWidgetId, 
  updateeditwidgetdetails, 
  updateselectedbasicprops, 
  updateselectedextendedprops 
} from "../../../store/cofig_data"; 

export default function Widgetcard (props) {
    const theme = useSelector((state) => state.themedata.theme)
    const dispatch = useDispatch()

    const [editdialog, setEditdialog] = useState(false)
    const [deletedialog, setDeletedialog] = useState(false)
    const [toggleval, setToggleval] = useState(false)
    var propsbasic = props.widgetdprops.props.basic
    
    useEffect(() => {
        //console.log("widget props ", props)        
    },[])

    const handleeditclick = () => {
        // These must be set to the correct values
        dispatch(setEditWidgetMode("Edit"));
        dispatch(setEditWidgetId(props.widgetdprops.id));
        dispatch(updateeditwidgetdetails(props.widgetdprops.widgettype));
        dispatch(updateselectedbasicprops(JSON.stringify(props.widgetdprops.props.basic)));
        dispatch(updateselectedextendedprops(JSON.stringify(props.widgetdprops.props.extended)));
        setEditdialog(true);
    }

    const handleCloseeditdialog = () => {
        setEditdialog(false)
    }

    const handleclosedeletedialog = () => {
        setDeletedialog(false)
    }

    const handledeleteclick = () => {
        setDeletedialog(true)
    }

    const handlethemetoggel = (checked) => {
        if(checked) {
            setToggleval(checked)
            dispatch(updatetheme('dark'))
        } else {
            setToggleval(checked)
            dispatch(updatetheme('light'))
        }    
    }

    const handledeletwidget = () => {
        props.deletecallback(props.widgetdprops.id)
        setDeletedialog(false)
    }

    const handleSaveEditWidget = () => {
       if (props.callbackupdateaddflag) {
            props.callbackupdateaddflag(); 
        }
        setEditdialog(false);
    };

    //props.widgetdprops.props.basic
    return(
        <div style={{height: '100%'}}>
            <Card 
                elevation={0} 
                sx={{
                    backgroundColor: theme === 'dark' ? propsbasic.color.dark.background : propsbasic.color.light.background, 
                    borderRadius: propsbasic.border.borderradius+'px', 
                    border: propsbasic.border.bordersize+'px solid',
                    borderColor: theme === 'dark' ? propsbasic.color.dark.border : propsbasic.color.light.border,
                    height: '100%'
                }}> 
                <Box sx={{height: '30px', width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <Typography 
                        sx={{
                            marginLeft: '15px',
                            marginTop:"8px", 
                            color: theme === 'dark' ? propsbasic.color.dark.text : propsbasic.color.light.text,
                            fontSize: '16px', 
                            fontWeight: 700,
                            fontFamily:"Roboto"
                        }}
                    > 
                        {propsbasic.widgetname} 
                    </Typography>
                    <Typography style={{flexGrow: 1}}> </Typography>
                    <IconButton style={{margin: '0px', padding: '0px'}} onClick={handleeditclick}>
                        <EditOutlinedIcon style={{color: theme === 'dark' ? propsbasic.color.dark.text : propsbasic.color.light.text}}/>
                    </IconButton>
                    <IconButton style={{margin: '0px', padding: '0px'}} onClick={handledeleteclick}>
                        <DeleteOutlineOutlinedIcon style={{color: theme === 'dark' ? propsbasic.color.dark.text : propsbasic.color.light.text}}/>
                    </IconButton>
                </Box>
                <Box sx={{height: '100%'}}>
                    {props.widgetdprops.widgettype === "Single Value" && <Valuescard extendedprops = {props.widgetdprops.props.extended}/>}
                    {/* {props.widgetdprops.widgettype === "Leaflet Map" && <Leafletmapcard extendedprops = {props.widgetdprops.props.extended}/>} */}
                    {props.widgetdprops.widgettype === "Line Chart" && <Linechartcard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Bar Chart" && <Barchartcard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Area Chart" && <Areachartcard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Pie Chart" && <Piechartcard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Google Map" && <Googlemaps extendedprops={props.widgetdprops.props.extended}/>}
                    {/* {props.widgetdprops.widgettype === "Azure Map" && <Azuremaps extendedprops={props.widgetdprops.props.extended}/>} */}
                    {props.widgetdprops.widgettype === "Circular Gauge" && <Circulargaugecard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Semi Circular Gauge" && <Semicirculargaugecard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Speed Gauge" && <Speedgauge extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Linear Gauge" && <Lineargauge extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Temperature Gauge" && <Temperaturegauge extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Timeseries Table" && <Timeseriestable extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Status" && <Statuscard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Set Value" && <Setdatacard extendedprops={props.widgetdprops.props.extended}/>}
                    {props.widgetdprops.widgettype === "Switch" && <Switchcard extendedprops={props.widgetdprops.props.extended}/>}
                </Box>
            </Card>

            <Dialog
                open={editdialog}
                onClose={handleCloseeditdialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ 
                    sx: { 
                        borderRadius: "0px",
                        bgcolor: 'var(--secondary-background)',//theme==='dark'?'#1E1E1E':'#FFFFFF',
                        maxHeight:'850px',
                        maxWidth:'1950px',
                        width:"1450px",
                        height:"800px",
                        overflow:'auto',
                        color: 'var(--SecondaryText)', //theme==='dark'?'#C1C1C1':'#7E7E7E',
                    } 
                }}
                
            >
                <DialogTitle id="alert-dialog-title" style={{backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF', color: '#005C8E'}}>
                    {"Update Widget"}
                </DialogTitle>
                <DialogContent style={{backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    <div style={{height: 'calc(100% - 40px)'}}>
                        <div style={{display: 'flex', marginBottom: '20px'}}>
                            <div style={{flexGrow: 1}}></div>
                            <ConfigProvider
                                theme={{
                                    token: {
                                        //colorBgContainer:'#000000',
                                        motionDurationMid:'0.2s',
                                        borderRadius:'20px',
                                        colorPrimary:'#005C8E',colorSecondary:'#000000',
                                    },
                                    components:{
                                        Switch:{
                                        //borderColor:'var(--SecondaryText)',
                                        //trackBg:'#ffffff',
                                        trackHeight:'28px',
                                        trackMinWidth:'58px',
                                        handleShadow:'0px',
                                        handleBg:  (theme=='light')?"#EFEFEF":"#E0E0E0",
                                        handleSize:20,
                                        trackPadding:4
                                        }
                                    },
                                }}
                            >
                                <AntdSwitch value={toggleval} defaultChecked={false} onChange={handlethemetoggel}/>
                            </ConfigProvider>
                        </div>
                        <Widgetcreateupdate type={"Edit"}/>
                    </div>
                </DialogContent>
                <DialogActions style={{backgroundColor: theme === 'dark' ? '#1E1E1E' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    <button 
                        style={{
                            padding: '6px 15px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: 'transparent',
                            color: '#7E7E7E',
                            //padding: '8px 45px',
                            border: '1px solid',
                            borderColor:'#7E7E7E' ,
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                            marginRight: '10px'
                        }}
                        onClick={handleCloseeditdialog}
                    >
                        Close
                    </button>
                    <button 
                        style={{
                            padding: '8px 20px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: '#005C8E',
                            color: '#FFFFFF',
                            //padding: '8px 45px',
                            border: 'none',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                        }}
                        onClick={handleSaveEditWidget}
                    >
                        Save
                    </button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={deletedialog}
                onClose={handleclosedeletedialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                PaperProps={{ sx: { borderRadius: "0px" } }}
            >
                <DialogTitle id="alert-dialog-title" style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    {"Conformation Info"}
                </DialogTitle>
                <DialogContent style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    Do you want to delete ?
                </DialogContent>
                <DialogActions style={{backgroundColor: theme === 'dark' ? '#000000' : '#EFEFEF', color: theme === 'dark' ? '#FFFFFF' : '#3C3C3C'}}>
                    <button 
                        style={{
                            padding: '6px 15px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: 'transparent',
                            color: '#7E7E7E',
                            //padding: '8px 45px',
                            border: '1px solid',
                            borderColor:'#7E7E7E',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                            marginRight: '10px'
                        }}
                        onClick={handleclosedeletedialog}
                    >
                        Close
                    </button>
                    <button 
                        style={{
                            padding: '8px 20px',
                            //width: '137px',
                            //height: '35px',
                            backgroundColor: '#005C8E',
                            color: '#FFFFFF',
                            //padding: '8px 45px',
                            border: 'none',
                            borderRadius: '20px',
                            fontSize: '16px',
                            fontWeight: 700,
                            fontFamily: 'Roboto',
                            cursor: 'pointer',
                        }}
                        onClick={handledeletwidget}
                    >
                        Delete
                    </button>
                </DialogActions>
            </Dialog>
        </div>
    )
}